import { create } from 'zustand';

import type { EFeatureType } from '@common/types';

type TFeatureState = {
  featureType: keyof typeof EFeatureType;
  setFeatureType: (featureType: keyof typeof EFeatureType) => void;
};

const featureStore = create<TFeatureState>((set) => ({
  featureType: 'BUSINESS',
  setFeatureType: (featureType) => set({ featureType }),
}));

export const useFeature = () => {
  const featureType = featureStore((state) => state.featureType);
  const setFeatureType = featureStore((state) => state.setFeatureType);
  return { featureType, setFeatureType };
};
